import {NgModule} from '@angular/core';
import {DynamicZyxDaemonService} from './dynamic-zyx-daemon.service';

@NgModule({
    providers: [
        DynamicZyxDaemonService
    ]
})
export class DynamicZyxGlobalDaemonModule {}
